import React from "react";
import useSettings from "src/hooks/useSettings";
import {THEMES} from "src/constants";

const Logo = ({color = "auto", ...rest}) => {
    const {settings} = useSettings();

    const file =
        color === "auto"
            ? settings.theme === THEMES.DARK
                ? "logo-white.png"
                : "logo-black.png"
            : "logo-" + color + ".png";

    return <img alt={`${settings.logo}`} src={`/static/${settings.logo}/${file}`} {...rest} />;
};

export default Logo;
